/* Japan Clothing — Free Gift on Checkout Intercept — v7
 * FIX: only intercept the "Checkout" main button, never Apple Pay / Google Pay
 *      redirect to /checkout directly, never submit the /cart form
 */
(function() {
  'use strict';

  var GIFT_VARIANT_ID = 42973492936937;
  var THRESHOLD_CENTS = 10000;
  var GIFT_NAME = "Japanese fan 'Wave of Kanagawa'";
  var GIFT_PROPERTY_KEY = '_free_gift';

  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function findGift(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === GIFT_VARIANT_ID &&
          it.properties && it.properties[GIFT_PROPERTY_KEY]) return it;
    }
    return null;
  }

  // ===== Visual progress bar =====
  function updateBar() {
    var bar = document.querySelector('[data-gift-bar]');
    if (!bar) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = cart.total_price || 0;
        var gift = findGift(cart);
        var effective = gift ? (total - gift.final_line_price) : total;
        var itemsWithoutGift = (cart.item_count || 0) - (gift ? gift.quantity : 0);
        var percent = Math.min(100, Math.round((effective * 100) / THRESHOLD_CENTS));
        var unlocked = effective >= THRESHOLD_CENTS;
        var remaining = Math.max(0, THRESHOLD_CENTS - effective);

        if (itemsWithoutGift === 0) { bar.classList.add('hidden'); return; }
        bar.classList.remove('hidden');

        var fill = bar.querySelector('[data-gift-bar-fill]');
        if (fill) {
          fill.style.width = percent + '%';
          fill.classList.toggle('is-complete', unlocked);
        }

        var icon = bar.querySelector('[data-gift-icon]');
        var msg = bar.querySelector('[data-gift-message]');
        if (icon && msg) {
          if (unlocked) {
            icon.classList.remove('cart-gift__icon--gift');
            icon.classList.add('cart-gift__icon--check');
            icon.textContent = '\u2713';
            msg.innerHTML = 'Free gift unlocked: <strong>' + GIFT_NAME + '</strong>';
          } else {
            icon.classList.remove('cart-gift__icon--check');
            icon.classList.add('cart-gift__icon--gift');
            icon.textContent = '\uD83C\uDF81';
            msg.innerHTML = 'You\u2019re <strong>' + fmtMoney(remaining) + '</strong> away from a free <strong>' + GIFT_NAME + '</strong>';
          }
        }
      })
      .catch(function() {});
  }

  var barScheduled = false;
  function scheduleBarUpdate() {
    if (barScheduled) return;
    barScheduled = true;
    setTimeout(function() {
      barScheduled = false;
      updateBar();
    }, 400);
  }

  var mo = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('[data-gift-bar], .cart__item, [data-items-holder]')) ||
            (n.querySelector && n.querySelector('[data-gift-bar]'))) {
          scheduleBarUpdate();
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  ['theme:cart:update', 'cart:updated', 'cart:refresh'].forEach(function(evt) {
    document.addEventListener(evt, scheduleBarUpdate);
  });
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-toggle]')) scheduleBarUpdate();
  });

  // ===== Checkout intercept =====
  // We ONLY intercept the main "Checkout" button (name="checkout" or .cart__checkout)
  // Apple Pay / Google Pay / Shop Pay buttons are NOT in this selector, so they are
  // NOT touched — they will proceed to their own native checkout.

  var isProcessing = false;

  document.addEventListener('click', function(e) {
    // Only match the main checkout submit button
    var btn = e.target.closest('button[name="checkout"]');
    if (!btn) return;

    // Explicitly skip the additional-checkout-buttons (Apple Pay / Shop Pay / Google Pay)
    if (btn.closest('.additional-checkout-buttons')) return;
    if (btn.closest('[data-additional-checkout-button]')) return;

    if (isProcessing) { e.preventDefault(); e.stopPropagation(); return; }

    // Check cart first; if all good, add gift and then redirect
    e.preventDefault();
    e.stopPropagation();
    isProcessing = true;
    btn.setAttribute('disabled', 'disabled');

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var gift = findGift(cart);
        var effective = (cart.total_price || 0) - (gift ? gift.final_line_price : 0);

        if (gift || effective < THRESHOLD_CENTS) {
          // No need to add gift — go straight to checkout
          window.location.href = '/checkout';
          return;
        }

        // Add gift then redirect
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { '_free_gift': 'true' } }]
          })
        }).then(function() {
          window.location.href = '/checkout';
        });
      })
      .catch(function() {
        // If anything fails, still let the user reach checkout
        window.location.href = '/checkout';
      });
  }, true);

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBarUpdate);
  } else {
    scheduleBarUpdate();
  }
})();
